import React from 'react';
import {Form} from 'antd';
import TipLabel from 'components/TipLabel';
import TipsView from 'components/TipsView';

const FormItem = Form.Item;
const defaultImgSize = {imgHeight:281, width:200};
const getLabel = (label, dec, img)=>{
    let tip;
    if(dec || img){
        const sizeConfig = img ? defaultImgSize : {width:400};
        tip = <TipsView textMap={{dec, img, ...sizeConfig}}/>;
    }
    return <TipLabel label={label} content={tip}/>;
};
const SceneFormItem = props => {
    const {label, dec, img, children, ...formItemProps} = props;
    return <FormItem {...formItemProps} colon={false} label={getLabel(label, dec, img)}>{children}</FormItem>;
};
export default SceneFormItem;



// WEBPACK FOOTER //
// ./src/components/SceneFormItem/index.js